import { PageHeader } from '@/shared/components/ui/PageHeader';
import { MessageCircle } from 'lucide-react';
import { WhatsappFullClient } from '../components/WhatsappFullClient';
import { useAuthStore } from '@/shared/stores/auth.store';

export function WhatsappInboxPage() {
  const { user } = useAuthStore();
  const canManage = user?.role === 'superadmin' || user?.role === 'admin';

  return (
    <div className="flex flex-col overflow-hidden bg-surface">
      <div className="hidden border-b border-outline bg-surface px-4 py-3 md:block">
        <PageHeader
          icon={MessageCircle}
          eyebrow="Communication"
          title="WhatsApp Team Inbox"
          description="Official RBM Oil Corporation WhatsApp Business chat"
        />
      </div>
      {/* A definite height, so the conversation scrolls inside the page. */}
      <div className="h-[calc(100dvh-4rem)] min-h-[460px] md:h-[calc(100dvh-12rem)]">
        <WhatsappFullClient canManage={canManage} />
      </div>
    </div>
  );
}
